import { GET_ANNOUNCE_STATUS_LIST, ANNOUNCE_LIST_ACTION, ANNOUNCE_WRITE_ACTION } from "./action";
import { ANNOUNCE_STATUS_LIST_MUTATION } from "./mutation";
import ApiService from "@/services/ApiService";
import apiPath from "@/services/apiPath";

import { CATEGORY_ACTION } from "../category/action";

export default {
  state: {
    statusList: [],
  },
  actions: {
    async [GET_ANNOUNCE_STATUS_LIST](context) {
      if (context.state.statusList.length > 0) return; // 한번만 호출.

      const result = await ApiService.shared.getData(apiPath.ANNOUNCE_STATUS_LIST);

      this.commit({
        type: ANNOUNCE_STATUS_LIST_MUTATION,
        items: result.data || [],
      });
    },
    async [ANNOUNCE_LIST_ACTION](context) {
      await context.dispatch(GET_ANNOUNCE_STATUS_LIST);

      await context.dispatch(CATEGORY_ACTION.GET_LIST_0);
    },
    async [ANNOUNCE_WRITE_ACTION](context) {
      await context.dispatch(CATEGORY_ACTION.GET_LIST_0);
    },
  },
  mutations: {
    [ANNOUNCE_STATUS_LIST_MUTATION](state, payload) {
      // code 로 들어오는 값을 기준 값으로 (value)
      const arr = payload.items;

      arr.forEach((element) => {
        element.value = element.code;
      });

      state.statusList = arr;
    },
  },
};
